

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { RiferimentoFascicoloCartaceoDTO } from "../dto/riferimento-fascicolo-cartaceoDTO";
import { RiferimentoFascicoloCartaceoVO } from "../vo/riferimento-fascicolo-cartaceoVO";



@Injectable({
    providedIn: 'root'
})
export class MapperRiferimentoFascicoloCartaceo implements MapperInterface<RiferimentoFascicoloCartaceoDTO, RiferimentoFascicoloCartaceoVO> {

    convertVoToDto(vo: RiferimentoFascicoloCartaceoVO): RiferimentoFascicoloCartaceoDTO {
        if (vo != null) {
            const dto = new RiferimentoFascicoloCartaceoDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.collocazioneFisica = vo.collocazioneFisica;
            dto.descrizioneContenuto = vo.descrizioneContenuto;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: RiferimentoFascicoloCartaceoDTO): RiferimentoFascicoloCartaceoVO {
        if (dto != null) {
            const vo = new RiferimentoFascicoloCartaceoVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.collocazioneFisica = dto.collocazioneFisica;
            vo.descrizioneContenuto = dto.descrizioneContenuto;

            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: RiferimentoFascicoloCartaceoVO[]): RiferimentoFascicoloCartaceoDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: RiferimentoFascicoloCartaceoDTO[]): RiferimentoFascicoloCartaceoVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
